import calendarLabels from "common/views/calendar/labels";
import LabelProvider from "core/components/label/LabelProvider";


export default LabelProvider.create({

	...calendarLabels.getData()

});



// WEBPACK FOOTER //
// ./src/panels/entriesCalendar/EntriesCalendar.labels.ts